function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 2.16406,
  y: 19.3154,
  width: 286.663,
  height: 82,
  rx: 8,
  transform: "rotate(-3.5 2.16406 19.3154)",
  fill: "#D0FFE9",
  stroke: "#72D0BF",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M66.5542 74.863L66.3101 70.8705C66.1807 68.7527 65.2153 66.7731 63.6262 65.3671C62.0372 63.9612 59.9547 63.2441 57.8369 63.3735L43.863 64.2277C41.7452 64.3572 39.7656 65.3226 38.3597 66.9116C36.9537 68.5007 36.2366 70.5831 36.366 72.7009L36.6101 76.6935",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.5542 74.863L66.3101 70.8705C66.1807 68.7527 65.2153 66.7731 63.6262 65.3671C62.0372 63.9612 59.9547 63.2441 57.8369 63.3735L43.863 64.2277C41.7452 64.3572 39.7656 65.3226 38.3597 66.9116C36.9537 68.5007 36.2366 70.5831 36.366 72.7009L36.6101 76.6935",
  stroke: "#007C66",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.3617 55.8151C54.7718 55.5455 58.1283 51.7519 57.8587 47.3419C57.5891 42.9318 53.7955 39.5753 49.3855 39.8449C44.9754 40.1145 41.6189 43.9081 41.8885 48.3181C42.1581 52.7281 45.9517 56.0847 50.3617 55.8151Z",
  fill: "white",
  stroke: "#007C66",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.33 54.7777L71.5666 58.5262L79.0636 50.053",
  stroke: "#007C66",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M120.013 47.084C121.968 46.9644 123.008 45.9044 123.392 44.9927L123.484 44.987L123.583 46.603L125.83 46.4656L125.35 38.6164C125.14 35.1767 122.389 34.6575 120.512 34.7723C118.372 34.9032 116.455 35.8855 115.817 38.0872L118.01 38.4475C118.297 37.588 119.11 36.7273 120.656 36.6327C122.141 36.5418 122.951 37.2725 123.033 38.6114L123.036 38.6653C123.087 39.5041 122.224 39.5414 120.116 39.9176C117.892 40.3162 115.635 41.0412 115.799 43.7269C115.941 46.0508 117.766 47.2214 120.013 47.084ZM120.401 45.2065C119.1 45.2861 118.125 44.7587 118.056 43.6198C117.98 42.3885 119.046 41.8831 120.367 41.6246C121.107 41.479 122.865 41.1706 123.175 40.8195L123.269 42.3432C123.354 43.7437 122.317 45.0893 120.401 45.2065Z",
  fill: "#007C66"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M133.334 46.2384C135.488 46.1066 136.254 44.7389 136.624 43.9594L136.816 43.9476L136.929 45.7868L139.176 45.6493L138.212 29.8895L135.911 30.0302L136.269 35.8863L136.131 35.8948C135.67 35.1891 134.804 33.8982 132.603 34.0328C129.748 34.2074 127.785 36.5906 128.019 40.4228C128.253 44.2474 130.463 46.4139 133.334 46.2384ZM133.722 44.245C131.667 44.3707 130.487 42.6277 130.342 40.2576C130.198 37.9106 131.137 36.0843 133.215 35.9573C135.223 35.8344 136.401 37.4076 136.552 39.8778C136.704 42.3633 135.707 44.1236 133.722 44.245Z",
  fill: "#007C66"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M151.848 33.0102L149.378 33.1612L146.949 42.4396L146.826 42.4472L143.276 33.5345L140.806 33.6856L145.822 45.2428L148.285 45.0922L151.848 33.0102Z",
  fill: "#007C66"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M154.734 44.6978L157.034 44.5571L156.311 32.7372L154.011 32.8779L154.734 44.6978ZM155.061 30.9831C155.854 30.9346 156.478 30.2785 156.432 29.5244C156.386 28.7702 155.686 28.1874 154.893 28.2359C154.093 28.2848 153.477 28.9481 153.523 29.7023C153.569 30.4564 154.261 31.032 155.061 30.9831Z",
  fill: "#007C66"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M168.441 34.8918C167.851 33.0819 166.339 31.9694 163.784 32.1257C161.114 32.289 159.307 33.813 159.435 35.9061C159.537 37.5837 160.621 38.6374 162.868 38.9943L164.895 39.3106C166.05 39.4948 166.612 39.9702 166.657 40.709C166.713 41.6247 165.779 42.4001 164.271 42.4924C162.894 42.5766 161.972 42.0382 161.624 40.8932L159.421 41.3678C159.934 43.4374 161.745 44.5084 164.4 44.346C167.255 44.1714 169.14 42.5345 169.009 40.3952C168.907 38.7253 167.782 37.7591 165.581 37.3917L163.677 37.0756C162.358 36.8473 161.769 36.443 161.728 35.6423C161.665 34.7347 162.61 34.028 163.918 33.948C165.35 33.8605 166.06 34.6126 166.378 35.3888L168.441 34.8918Z",
  fill: "#007C66"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M176.857 43.5841C179.434 43.4265 181.181 42.0452 181.586 40.0894L179.384 39.8301C179.037 40.9713 178.072 41.602 176.763 41.682C174.793 41.8025 173.392 40.606 173.191 38.332L181.594 37.818L181.544 37.0024C181.283 32.7315 178.626 31.2179 175.948 31.3817C172.654 31.5831 170.638 34.2245 170.86 37.8566C171.084 41.5273 173.371 43.7973 176.857 43.5841ZM173.093 36.6078C173.083 34.9246 174.21 33.3958 176.08 33.2815C177.865 33.1723 179.116 34.4243 179.234 36.2322L173.093 36.6078Z",
  fill: "#007C66"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M195.194 42.4625C198.526 42.2587 200.555 39.6862 200.331 36.0309C200.106 32.3526 197.779 30.0464 194.447 30.2502C191.115 30.454 189.087 33.0266 189.312 36.7049C189.535 40.3601 191.862 42.6663 195.194 42.4625ZM195.084 40.5306C192.906 40.6638 191.774 38.8252 191.635 36.5551C191.497 34.2927 192.395 32.3068 194.573 32.1736C196.735 32.0413 197.868 33.903 198.007 36.1654C198.146 38.4355 197.246 40.3983 195.084 40.5306Z",
  fill: "#007C66"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M205.129 34.5711C205.014 32.6858 206.102 31.5379 207.703 31.44C209.265 31.3444 210.274 32.31 210.379 34.026L210.822 41.2673L213.123 41.1265L212.663 33.6083C212.484 30.6841 210.782 29.2511 208.366 29.3989C206.588 29.5076 205.477 30.4021 205.007 31.6898L204.861 31.6988L204.743 29.775L202.535 29.91L203.258 41.7299L205.559 41.5892L205.129 34.5711Z",
  fill: "#007C66"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M118.214 74.1199L120.515 73.9792L120.074 66.7611C119.979 65.2143 121.104 64.0256 122.735 63.9258C123.212 63.8966 123.756 63.9483 123.944 63.9909L123.809 61.79C123.577 61.7734 123.121 61.7781 122.829 61.7959C121.444 61.8807 120.306 62.7381 119.953 64.0341L119.83 64.0417L119.715 62.164L117.491 62.3L118.214 74.1199Z",
  fill: "#007C66"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M131.216 73.5641C133.794 73.4064 135.54 72.0252 135.946 70.0694L133.744 69.8101C133.397 70.9513 132.431 71.582 131.123 71.662C129.153 71.7825 127.752 70.586 127.551 68.312L135.954 67.798L135.904 66.9823C135.643 62.7115 132.986 61.1979 130.308 61.3617C127.014 61.5631 124.998 64.2045 125.22 67.8366C125.444 71.5073 127.731 73.7773 131.216 73.5641ZM127.453 66.5878C127.443 64.9046 128.57 63.3758 130.44 63.2614C132.225 63.1523 133.475 64.4043 133.594 66.2122L127.453 66.5878Z",
  fill: "#007C66"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M142.282 72.9105C144.236 72.791 145.276 71.731 145.66 70.8192L145.753 70.8135L145.852 72.4295L148.099 72.2921L147.619 64.443C147.408 61.0032 144.658 60.484 142.78 60.5988C140.641 60.7297 138.723 61.712 138.086 63.9138L140.278 64.274C140.565 63.4145 141.378 62.5538 142.925 62.4592C144.41 62.3684 145.219 63.099 145.301 64.438L145.304 64.4918C145.356 65.3306 144.493 65.3679 142.384 65.7441C140.161 66.1427 137.903 66.8678 138.068 69.5534C138.21 71.8774 140.035 73.0479 142.282 72.9105ZM142.669 71.0331C141.368 71.1126 140.394 70.5852 140.324 69.4463C140.249 68.2151 141.315 67.7096 142.635 67.4512C143.376 67.3055 145.133 66.9972 145.444 66.646L145.537 68.1697C145.623 69.5702 144.585 70.9159 142.669 71.0331Z",
  fill: "#007C66"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M152.5 56.2041L150.199 56.3448L151.163 72.1047L153.464 71.9639L152.5 56.2041Z",
  fill: "#007C66"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M162.566 75.8563L164.866 75.7156L164.483 69.444L164.621 69.4355C165.083 70.1642 166.01 71.4283 168.165 71.2965C171.027 71.1215 172.965 68.7012 172.731 64.8767C172.496 61.0444 170.25 58.9187 167.395 59.0933C165.202 59.2275 164.491 60.6149 164.128 61.3709L163.936 61.3827L163.819 59.4666L161.572 59.604L162.566 75.8563ZM164.188 65.376C164.037 62.9059 165.014 61.2009 167.022 61.078C169.108 60.9505 170.262 62.6487 170.405 64.9957C170.55 67.3659 169.584 69.2401 167.529 69.3658C165.551 69.4868 164.34 67.8616 164.188 65.376Z",
  fill: "#007C66"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M175.669 70.6058L177.97 70.4651L177.528 63.247C177.434 61.7003 178.558 60.5115 180.189 60.4117C180.667 60.3825 181.21 60.4342 181.398 60.4768L181.264 58.276C181.031 58.2593 180.576 58.264 180.283 58.2819C178.898 58.3666 177.761 59.224 177.408 60.5201L177.285 60.5276L177.17 58.65L174.946 58.786L175.669 70.6058Z",
  fill: "#007C66"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M188.556 70.0571C191.888 69.8533 193.916 67.2807 193.693 63.6255C193.468 59.9472 191.141 57.641 187.809 57.8448C184.477 58.0486 182.448 60.6212 182.673 64.2995C182.897 67.9547 185.223 70.2609 188.556 70.0571ZM188.445 68.1251C186.267 68.2583 185.135 66.4197 184.996 64.1496C184.858 61.8872 185.756 59.9013 187.934 59.7681C190.096 59.6359 191.23 61.4975 191.368 63.7599C191.507 66.03 190.607 67.9929 188.445 68.1251Z",
  fill: "#007C66"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M195.896 57.5046L196.664 70.0632C196.731 71.1636 196.314 71.7916 195.221 71.8585C195.091 71.8665 194.991 71.8726 194.852 71.8734L194.973 73.8587L195.419 73.8314C197.891 73.7111 199.111 72.308 198.966 69.9379L198.197 57.3639L195.896 57.5046ZM196.923 55.6112C197.716 55.5627 198.34 54.9066 198.294 54.1525C198.248 53.3983 197.548 52.8155 196.755 52.864C195.955 52.9129 195.339 53.5763 195.385 54.3304C195.431 55.0845 196.123 55.6601 196.923 55.6112Z",
  fill: "#007C66"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M207.124 68.9214C209.702 68.7637 211.448 67.3825 211.854 65.4267L209.652 65.1674C209.305 66.3086 208.339 66.9393 207.031 67.0193C205.061 67.1398 203.659 65.9433 203.458 63.6693L211.862 63.1553L211.812 62.3396C211.55 58.0688 208.893 56.5552 206.216 56.719C202.922 56.9204 200.905 59.5618 201.128 63.1939C201.352 66.8645 203.638 69.1346 207.124 68.9214ZM203.361 61.9451C203.35 60.2619 204.477 58.7331 206.347 58.6187C208.132 58.5095 209.383 59.7616 209.501 61.5695L203.361 61.9451Z",
  fill: "#007C66"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M219.727 68.1506C222.52 67.9797 224.226 66.1916 224.339 63.8752L222.1 64.0121C221.886 65.3074 220.939 66.1223 219.623 66.2027C217.676 66.3218 216.323 64.7748 216.165 62.1969C216.01 59.6652 217.19 57.9942 219.114 57.8765C220.576 57.7871 221.525 58.6559 221.839 59.749L224.079 59.612C223.686 57.2415 221.643 55.7754 218.957 55.9397C215.625 56.1435 213.624 58.7839 213.844 62.3929C214.062 65.9558 216.295 68.3605 219.727 68.1506Z",
  fill: "#007C66"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M231.823 55.3072L229.399 55.4555L229.226 52.6236L226.925 52.7644L227.098 55.5962L225.367 55.7021L225.48 57.549L227.211 57.4431L227.638 64.4226C227.762 66.5701 229.464 67.5087 231.278 67.3591C232.009 67.3067 232.493 67.1381 232.756 67.0216L232.224 65.1463C232.072 65.1864 231.792 65.2731 231.422 65.2957C230.676 65.3414 229.991 65.1361 229.91 63.8048L229.512 57.3023L231.936 57.1541L231.823 55.3072Z",
  fill: "#007C66"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M243.212 57.5072C242.622 55.6972 241.11 54.5848 238.555 54.741C235.884 54.9043 234.078 56.4283 234.206 58.5214C234.308 60.199 235.392 61.2527 237.639 61.6096L239.666 61.9259C240.821 62.1102 241.383 62.5856 241.428 63.3243C241.484 64.24 240.55 65.0155 239.042 65.1077C237.665 65.192 236.743 64.6536 236.395 63.5085L234.192 63.9831C234.705 66.0527 236.516 67.1237 239.171 66.9613C242.026 66.7867 243.911 65.1498 243.78 63.0105C243.678 61.3407 242.553 60.3745 240.352 60.007L238.448 59.6909C237.129 59.4626 236.54 59.0584 236.499 58.2576C236.436 57.35 237.381 56.6434 238.689 56.5634C240.121 56.4758 240.831 57.228 241.149 58.0041L243.212 57.5072Z",
  fill: "#007C66"
});

var _ref24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  fill: "white",
  transform: "translate(32.1484 34.4883) rotate(-3.5)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1"
}, /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  fill: "white",
  transform: "translate(32.0508 34.8936) rotate(-3.49802)"
})));

var SvgMentor2 = function SvgMentor2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 103,
    viewBox: "0 0 295 103",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMentor2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Mentor2.45b4130f.svg";
export { ForwardRef as ReactComponent };